// extracted by mini-css-extract-plugin
export var borderRadius = "_68-4";
export var large = "_68-3";
export var logoContainer = "_68-0";
export var nameLogo = "_68-2";
export var small = "_68-1";